/** 
 * All trailing operation. A trailing operator is an operation which ouside the nutrient code (-> @NutCode@:operator instead of @NutCode:operator@)
 */
export const ALL_TRAILING_OPERATORS = [ 'capped' ] ;
/** The delimitor which frames an entry nutrient code in an equation */
export const DELIMITER_FOR_ENTRY_NUT = "@" ;
/** The delimitor which frames a calculated nutrient code in an equation */
export const DELIMITER_FOR_CALC_NUT = "$" ;
/** The delimitor for calculated nutrient for equation for RegExp syntaxe */
const REGEXP_DELIMITER_CALC_NUT = "\\" + DELIMITER_FOR_CALC_NUT ;

/** String to list all possible Entry nutrient with trailing operators in RegExp syntax */
const STR_REG_EXP_FOR_ENTRY_NUTRIENT = DELIMITER_FOR_ENTRY_NUT + "(\\S+?)(:(.*?))?" + DELIMITER_FOR_ENTRY_NUT + "(:(" + ALL_TRAILING_OPERATORS.join('|') + "))?" ;
/** Number of groups available in regExp for Entry Nutrient */
const NB_GRP_INDEX_IN_ENTRY_NUT_REGEXP = 5 ;
/** Index of the group for the code of nutriment in regExp for Entry Nutrient */ 
export const ENTRY_NUT_GRP_INDEX_FOR_NUT_CODE = 1 ;
/** Index of the group for the operator which is not trailing (-> @NutCode:operator@) in regExp for Entry Nutrient */
export const ENTRY_NUT_GRP_INDEX_FOR_NOT_TRAILING_OP = 3 ;
/** Index of the group for the operator which is trailing (-> @NutCode@:operator) in regExp for Entry Nutrient */
export const ENTRY_NUT_GRP_INDEX_FOR_TRAILING_OP = 5 ;

/** String to list all possible calculated nutrient in RegExp syntax */
const STR_REG_EXP_FOR_CALC_NUTRIENT = REGEXP_DELIMITER_CALC_NUT + "(\\S+?)(#(.*?))?" + REGEXP_DELIMITER_CALC_NUT + "(:(" + ALL_TRAILING_OPERATORS.join('|') + "))?";
/** Index of the group for the code of nutriment in regExp for calculated Nutrient */
const CALC_NUT_GRP_INDEX_FOR_NUT_CODE = 1 ;
/** Index of the group for the matrix in regExp for calculated Nutrient */
export const CALC_NUT_GRP_INDEX_FOR_MATRIX = 3 ;
/** Index of the group for the operator which is trailing (-> $NutCode§:operator) in regExp for entry Nutrient */
export const CALC_NUT_GRP_INDEX_FOR_TRAILING_OP = 5 ;

/** String to list all possible nutrients in RegExp syntax */
const STR_REG_EXP_FOR_ALL_NUTRIENT = STR_REG_EXP_FOR_ENTRY_NUTRIENT + '|' + STR_REG_EXP_FOR_CALC_NUTRIENT ;
/** Index of nutrient code from Caculated Nutrient in regExp for all nutrient RegExp */
export const ALL_NUT_GRP_INDEX_FOR_NUT_CODE_FROM_CALC_NUT = CALC_NUT_GRP_INDEX_FOR_NUT_CODE + NB_GRP_INDEX_IN_ENTRY_NUT_REGEXP ;

/** Single RegExp to treat with a complete Entry nutrient (which can include trailing operator) */
export const SINGLE_REG_EXP_FOR_ENTRY_NUT = new RegExp(STR_REG_EXP_FOR_ENTRY_NUTRIENT) ;
/** Single RegExp to treat with a calculated nutrient */
export const SINGLE_REG_EXP_FOR_CALC_NUT = new RegExp(STR_REG_EXP_FOR_CALC_NUTRIENT) ;
/** Global RegExp to match all possible nutrients (with their trailing operators if there is) */
export const GLOBAL_REG_EXP_FOR_ALL_NUT = new RegExp(STR_REG_EXP_FOR_ALL_NUTRIENT, 'g') ;
/** Single RegExp to match all possible nutrients (with their trailing operators if there is) */
export const SINGLE_REG_EXP_FOR_ALL_NUT = new RegExp(STR_REG_EXP_FOR_ALL_NUTRIENT) ;

/** RegExp to check if a string start with an Entry nutrient */
export const REG_EXP_START_WITH_ENTRY_NUT = new RegExp("^(" + STR_REG_EXP_FOR_ENTRY_NUTRIENT + ")") ;
/** RegExp to check if a string start with a calculated nutrient */
export const REG_EXP_START_WITH_CALC_NUT = new RegExp("^(" + STR_REG_EXP_FOR_CALC_NUTRIENT + ")") ;